const state = {
  widgetImageGallery : {
    indexSilde : 0
  },
  widgetInteractive : {
    status : 'regular'
  }
}

const getters = {
  widgetImageGallery: () => {
    return state.widgetImageGallery;
  },
  widgetInteractive: () => {
    return state.widgetInteractive;
  },
  

}
const actions = {
  syncWidgetImageGallery({ commit },  {data} ) {
    commit('SET_WIDGET_IMAGE_GALLERY',  data );
  },
  syncWidgetInteractive({ commit },  {data} ) {
    commit('SET_WIDGET_INTERACTIVE',  data );
  },
}
const mutations = {
  SET_WIDGET_IMAGE_GALLERY(state, data) {
    const newObject = { ...state.widgetImageGallery, ...data }
    Object.keys(newObject).forEach(key => {
      state.widgetImageGallery[key] = newObject[key]
    })
  },
  SET_WIDGET_INTERACTIVE(state, data) {
    const newObject = { ...state.widgetInteractive, ...data }
    Object.keys(newObject).forEach(key => {
      state.widgetInteractive[key] = newObject[key]
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};